import { render, staticRenderFns } from "./constructionPage.vue?vue&type=template&id=684e465a&scoped=true"
import script from "./constructionPage.vue?vue&type=script&lang=js"
export * from "./constructionPage.vue?vue&type=script&lang=js"
import style0 from "./constructionPage.vue?vue&type=style&index=0&id=684e465a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684e465a",
  null
  
)

export default component.exports